import React from 'react';
import { connect } from 'react-redux';
import { Formik , Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Container, Button, Grid, Card, Image, Divider, Header } from 'semantic-ui-react';
import  * as yup from 'yup';

import AddTitleBar from '../../titleBar/addTitleBar'
import { MyInput, MyTextArea } from '../../formikInput/input';
import UploadFile from '../../formikInput/fileUpload';

//Dropdowns
import ProductCategoryDropdown from '../../dropdowns/productCategoryDropdown';
import ProductMeasurementDropdown from '../../dropdowns/productMeasurementDropdown';

//Actions 
import { updateProduct } from '../../../redux/actions/productMasterActions'

const EditProduct = (props) => {

    const { createProduct } = props;

    const initialValues = {
        productName: '',
        productCode: '',
        cat: '',
        uom: '',
        height: '',
        width: '',
        length: '',
        gst: '',
        tds: '',
        price: '',
        Pdescp: '',
        openStock: '',
        sellPrice: '',
        Sdescp: '',
        reOrder: '',
    }

    const validateSchema = yup.object().shape({
        imageUpload: yup.mixed().required('Image is Required'),
        productName: yup.string().min(3, 'Must be more than 3 letters').required('Product Name is Required'),
        productCode: yup.string().min(3, 'Must be more than 3 letters').required('Product Code is Required'),
        cat: yup.string().required('Category is Required'),
        uom: yup.string().required('Unit of Measurement is Required'),
        height: yup.string().matches(/^[0-9]+$/, 'Ex. 123').required('Height is Required'),
        width: yup.string().matches(/^[0-9]+$/, 'Ex. 123').required('Width is Required'),
        length: yup.string().matches(/^[0-9]+$/, 'Ex. 123').required('Length is Required'),
        weight: yup.string(),
        gst: yup.string().matches(/^[0-9]+$/, 'Ex. 123').required('gst is Required'),
        tds: yup.string().matches(/^[0-9]+$/, 'Ex. 123').required('tds is Required'),
        price: yup.string().matches(/^[0-9]+$/, 'Invalid Amount').required('Price is Required'),
        Pdescp: yup.string().min(3, 'Must be more than 3 letters').required('Description is Required'),
        Sdescp: yup.string().min(3, 'Must be more than 3 letters').required('Description is Required'),
        openStock: yup.string().matches(/^[0-9]+$/, 'Invalid Stock').required('Stock is Required'),
        sellPrice: yup.string().matches(/^[0-9]+$/, 'Invalid Amount').required('Price is Required'),
        reOrder: yup.string().matches(/^[0-9]+$/, 'Invalid Amount').required('Order is Required'),
    })

    const onSubmit = values => {
        console.log("Product Onsubmit", values)

        const productData = {
            productName: values.productName,
            productCode: values.productCode,
            category: values.cat,
            uom: values.uom,
            weight: values.weight,
            height: values.height,
            width: values.width,
            length: values.length,
            image: values.imageUpload.base64.split(',')[1],
            gst: values.gst,
            tds: values.tds,
            purchasePrice: values.price,
            purchaseDescription: values.Pdescp,
            openingStock: values.openStock,
            sellingPrice: values.sellPrice,
            sellingDescription: values.Sdescp,
            reorderLevel: values.reOrder
        }

        createProduct(productData);
    }

    return (
        <React.Fragment>
            <AddTitleBar title="New Product" LinkName="/product" />
            <Container fluid className="m-2">
                <Formik
                initialValues={initialValues}
                validationSchema={validateSchema}
                onSubmit={onSubmit}>
                    {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                        <>
                            <Segment>
                                <div className="ui form tiny">
                                    <Container>
                                        <Grid>
                                            <Grid.Row>
                                                <Grid.Column width="8">
                                                    <Header size="small" className="p-bold-500" color="grey">Product Information</Header>
                                                    <FormUi.Group>
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Product Name</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="10">
                                                            <Fieldmik component={MyInput} name="productName" placeholder="Name" />
                                                            {touched.productName && errors.productName ? <strong className="w3-text-red w3-tiny font-weght-bold">{errors.productName}</strong> : '' }
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                    <FormUi.Group>
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Product Code</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="10">
                                                            <Fieldmik component={MyInput} name="productCode" placeholder="Code" />
                                                            {touched.productCode && errors.productCode ? <strong className="w3-text-red w3-tiny font-weght-bold">{errors.productCode}</strong> : '' }
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Category</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field>
                                                            <Fieldmik style={{ width: 300 }} component={ProductCategoryDropdown} name="cat" placeholder="Category" />
                                                            {touched.Category && errors.Category ? <strong className="w3-text-red w3-tiny font-weight-bold"> <br /> {errors.Category}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">UOM</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field >
                                                            <Fieldmik style={{ width: 300 }} component={ProductMeasurementDropdown} name="uom" placeholder="Select Measurement" />
                                                            {touched.uom && errors.uom ? <strong className="w3-text-red w3-tiny font-weight-bold"><br /> {errors.uom}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Weight</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field >
                                                            <Fieldmik style={{ width: 300 }} name="weight" placeholder="Weight" />
                                                            {touched.uom && errors.weight ? <strong className="w3-text-red w3-tiny font-weight-bold"><br /> {errors.weight}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Dimension</label>
                                                        </FormUi.Field>
                                                        <Fieldmik width="3" component={MyInput} name="height" placeholder="Height" />
                                                        <Fieldmik width="3" component={MyInput} name="width" placeholder="Width" />
                                                        <Fieldmik width="4" component={MyInput} name="length" placeholder="Length" />
                                                    </FormUi.Group>
                                                    {touched.height && errors.height ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.height}</strong> : ''}
                                                    {touched.width && errors.width ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.width}</strong> : ''}
                                                    {touched.length && errors.length ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.length}</strong> : ''}
                                                    
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">GST %</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="10">
                                                            <Fieldmik component={MyInput} name="gst" placeholder="GST%" />
                                                            {touched.gst && errors.gst ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.gst}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">TDS %</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="10">
                                                            <Fieldmik component={MyInput} name="tds" placeholder="TDS%" />
                                                            {touched.tds && errors.tds ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.tds}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                </Grid.Column>
                                                <Grid.Column >
                                                    <Header size="small" className="p-bold-500" color="grey"> &nbsp; </Header>
                                                    <FormUi.Group>
                                                        <FormUi.Field>
                                                            <Card>
                                                                <Image src={values.imageUpload ? values.imageUpload.base64 : 'assets/img/defalutproduct.png'} wrapped ui={false} />
                                                                <Card.Content extra>
                                                                    <Fieldmik component={UploadFile} typer={[".jpg", ".jpeg", ".png"]} buttonName="Upload Image" name="imageUpload" />
                                                                    {values.imageUpload ? 'Image Selected' : 'Please Select Image'}
                                                                    {touched.imageUpload && errors.imageUpload ? <strong className="w3-text-red w3-tiny font-weight-bold"><br /> {errors.imageUpload}</strong> : ''}
                                                                </Card.Content>
                                                            </Card>
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Divider fitted />
                                            <Grid.Row>
                                                <Grid.Column width="8">
                                                    <Header size="small" className="p-bold-500" color="grey">Purchase Information</Header>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Purchase Price(INR)</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="10">
                                                            <Fieldmik component={MyInput} name="price" placeholder="Rs." />
                                                            {touched.price && errors.price ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.price}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Description</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="10">
                                                            <Fieldmik component={MyTextArea} name="Pdescp" />
                                                            {touched.Pdescp && errors.Pdescp ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.Pdescp}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Opening Stock</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="10">
                                                            <Fieldmik component={MyInput} name="openStock" />
                                                            {touched.openStock && errors.openStock ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.openStock}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                </Grid.Column>
                                                <Grid.Column width="8">
                                                    <Header size="small" className="p-bold-500" color="grey">Sales Information</Header>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Selling Price(INR)</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="10">
                                                            <Fieldmik component={MyInput} name="sellPrice" />
                                                            {touched.sellPrice && errors.sellPrice ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.sellPrice}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Description</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="10">
                                                            <Fieldmik component={MyTextArea} name="Sdescp" />
                                                            {touched.Sdescp && errors.Sdescp ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.Sdescp}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                    <FormUi.Group >
                                                        <FormUi.Field width="6">
                                                            <label className="labelName mt-2">Reorder Level</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="10">
                                                            <Fieldmik component={MyInput} name="reOrder" />
                                                            {touched.reOrder && errors.reOrder ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.reOrder}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </Container>
                                </div>
                            </Segment>
                            <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                        </>
                    )}
                </Formik>
            </Container>
        </React.Fragment>
    )
}


export default connect( null, { updateProduct })(EditProduct)


